import React from 'react';
import * as Style from './style.module.scss';

const STAR_SIZE = 18;
const STAR_PATH =
    'M473.5 182l-162.9-24L236 11.2l-73.3 147.5L0 184.4l117.6 115.2-25.8 162.7 146-76.3 146.6 74.8L357 298.5z';
const FILL_COLOR = '#F5A623';
const EMPTY_COLOR = '#D4D4D4';

type NpsRatingProps = {
    npsRate: number | null;
};

const NpsRating: React.FC<NpsRatingProps> = ({ npsRate }) => {
    const instanceId = React.useId();

    if (npsRate == null) return null;

    const gradientId = `nps-star-grad-${instanceId}`;

    return (
        <div className={Style.npsRating}>
            <span className={Style.npsRatingText}>NPS derived rating:</span>
            <div className={Style.npsRatingStars}>
                {[1, 2, 3, 4, 5].map((i) => {
                    const fraction = Math.min(1, Math.max(0, npsRate - (i - 1)));
                    const isFull = fraction >= 1;
                    const isEmpty = fraction <= 0;

                    return (
                        <svg key={i} viewBox="0 0 480 480" width={STAR_SIZE} height={STAR_SIZE}>
                            {!isFull && !isEmpty && (
                                <defs>
                                    <linearGradient id={`${gradientId}-${i}`}>
                                        <stop
                                            offset={`${fraction * 100}%`}
                                            stopColor={FILL_COLOR}
                                        />
                                        <stop
                                            offset={`${fraction * 100}%`}
                                            stopColor={EMPTY_COLOR}
                                        />
                                    </linearGradient>
                                </defs>
                            )}
                            <path
                                d={STAR_PATH}
                                fill={
                                    isFull
                                        ? FILL_COLOR
                                        : isEmpty
                                          ? EMPTY_COLOR
                                          : `url(#${gradientId}-${i})`
                                }
                                stroke="none"
                            />
                        </svg>
                    );
                })}
            </div>
            <span className={Style.npsRatingText}>
                {Number.isInteger(npsRate) ? npsRate : npsRate.toFixed(1)} out of 5
            </span>
        </div>
    );
};

export default NpsRating;
